import React from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useVoyagerStore } from '../../stores/useVoyagerStore';

export const QUERY_PHASE_LABEL = { generating: 'Generating SQL...', executing: 'Executing query...' } as const;

const QueryExecuteTracker: React.FC = () => {
  // The Run's own phase, never the shared isLoading that catalog, model and report loads also set (#565).
  const queryPhase = useVoyagerStore((state) => state.queryPhase);
  const error = useVoyagerStore((state) => state.error);
  const errorDetails = useVoyagerStore((state) => state.errorDetails);
  const queryResults = useVoyagerStore((state) => state.queryResults);

  // Error state — compact pill; full diagnostic card lives in ResultsPane.
  if (error) {
    const headline = errorDetails?.title
      ? `${errorDetails.title} — see Results pane for details`
      : error;
    return (
      <Alert severity="error" variant="outlined" sx={{ py: 0 }}>
        {headline}
      </Alert>
    );
  }

  if (queryPhase !== 'idle') {
    const message = QUERY_PHASE_LABEL[queryPhase];
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CircularProgress size={20} />
        <Typography variant="body2" color="text.secondary">
          {message}
        </Typography>
      </Box>
    );
  }

  // Completed state
  if (queryResults) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <CheckCircleOutlineIcon color="success" fontSize="small" />
        <Typography variant="body2" color="success.main">
          Completed - {queryResults.row_count} row
          {queryResults.row_count !== 1 ? 's' : ''}
        </Typography>
      </Box>
    );
  }

  // Idle state
  return (
    <Typography variant="body2" color="text.secondary">
      Ready
    </Typography>
  );
};

export default QueryExecuteTracker;
